import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const SynonymIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='12' cy='12' r='11' fill={color} />
    <path fillRule='evenodd' clipRule='evenodd'
          d='M11.9999 5.71434C12.8678 5.71434 13.5714 6.41789 13.5714 7.28577C13.5714 8.15364 12.8678 8.85719 11.9999 8.85719C11.132 8.85719 10.4285 8.15364 10.4285 7.28577C10.4285 6.41789 11.132 5.71434 11.9999 5.71434ZM12.0784 10.4286C11.3407 10.4286 10.7427 10.9563 10.7427 11.6072V17.1072C10.7427 17.7581 11.3407 18.2858 12.0784 18.2858C12.8161 18.2858 13.4141 17.7581 13.4141 17.1072V11.6072C13.4141 10.9563 12.8161 10.4286 12.0784 10.4286Z'
          fill='white' />
  </svg>
)

export default SynonymIcon
